import { useEffect, useRef } from 'react';
import { useBadges } from '../context/BadgeContext';

export default function useFaviconBadge() {
  const { badges } = useBadges();
  const originalHref = useRef(null);

  useEffect(() => {
    const link = document.querySelector("link[rel*='icon']");
    if (!link) return;
    if (!originalHref.current) originalHref.current = link.href;

    const hasUnread = (badges?.notifs || 0) + (badges?.messages || 0) > 0;

    if (!hasUnread) {
      if (originalHref.current) link.href = originalHref.current;
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = originalHref.current || '/favicon.ico';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 32; canvas.height = 32;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, 32, 32);
        ctx.beginPath();
        ctx.arc(26, 6, 6, 0, 2 * Math.PI);
        ctx.fillStyle = '#ef4444';
        ctx.fill();
        link.href = canvas.toDataURL('image/png');
      } catch {}
    };
    img.onerror = () => {};
  }, [badges?.notifs, badges?.messages]);
}
